import { tKey } from 'ember-intl';

export const TROPHY_TYPES = {
  PRICE_PUSH_MILESTONE: 'PRICE_PUSH_MILESTONE',
  WEEKLY_HIGHLIGHT: 'WEEKLY_HIGHLIGHT',
} as const;

const pricePushMilestoneSubtitleKeys = [
  tKey('roi_trophies.price_push_milestone.subtitle_10'),
  tKey('roi_trophies.price_push_milestone.subtitle_100'),
  tKey('roi_trophies.price_push_milestone.subtitle_500'),
  tKey('roi_trophies.price_push_milestone.subtitle_1000'),
] as const;

export const PRICE_PUSH_MILESTONE_SUBTITLE_KEYS = Object.fromEntries(
  pricePushMilestoneSubtitleKeys.map((k) => [k, k]),
) as { [K in (typeof pricePushMilestoneSubtitleKeys)[number]]: K };

export type PricePushMilestoneSubtitleKey =
  keyof typeof PRICE_PUSH_MILESTONE_SUBTITLE_KEYS;
